var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.isDebugHub)?_c('v-chip',{staticClass:"ma-2",attrs:{"x-small":"","color":"orange"}},[_c('span',{staticClass:"text--white"},[_vm._v(_vm._s(_vm.$t('clients.components.debug-chip.debug')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }